import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    tableHeight: undefined,
    tableHeightNormal: undefined,
    selectRegionId: undefined,
    fullParentId: undefined
  },
  actions: {
  },
  mutations: {
    SET_NEW_HEIGHT: (state, { newHeight }) => {
      state.tableHeight = newHeight
    },
    SET_NEW_HEIGHTNORMAL: (state, { newHeight }) => {
      state.tableHeightNormal = newHeight
    },
    SET_REGION_ID: (state, { id }) => {
      state.selectRegionId = id
    },
    SET_FULLPARENT_ID: (state, { fullParentId }) => {
      state.fullParentId = fullParentId
    }
  },
  getters: {
    loadUsefulData: state => {
      return state.projects
    }
  },
  modules: {
  }
})
export default store



// WEBPACK FOOTER //
// ./src/common/store/store.js